/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { KEY_OPEN_TASK } from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/push-to-backend.tsx';
import type { State } from '../../model/types.tsx';
import { setNudgeStep } from '../nudge-step/index.tsx';
import { setHasNudgeActive } from '../set-has-nudge-active/index.tsx';

const openTask =
	(taskId: string): Action<State> =>
	({ setState }) => {
		setState({ openTask: taskId });

		pushToBackend({
			key: KEY_OPEN_TASK,
			value: taskId,
		});
	};

type NextOpenTaskOptions = {
	closeNudge?: boolean;
};
export const nextOpenTask =
	(taskId: string, { closeNudge }: NextOpenTaskOptions = {}): Action<State> =>
	({ dispatch, getState }) => {
		dispatch(openTask(taskId));
		const { completedTaskList } = getState();

		const taskIsCompleted = completedTaskList.includes(taskId);
		const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;

		if (closeNudge) {
			dispatch(setHasNudgeActive(false, taskId));
		} else {
			dispatch(setHasNudgeActive(taskIdExistsAndIsNotCompleted, taskId));
		}

		dispatch(setNudgeStep(''));
	};

export const nextAutoOpenTask =
	(taskId: string): Action<State> =>
	({ dispatch }) => {
		dispatch(openTask(taskId));
		dispatch(setHasNudgeActive(false, taskId));
		dispatch(setNudgeStep(''));
	};
